/**
 * Canonical MobiLauncher platform version.
 *
 * Scheme: CalVer `YY.Q.MMDD` with a `-beta` channel suffix during the beta.
 *   YY   = year, Q = calendar quarter (the release "train"),
 *   MMDD = build date within the quarter (the patch / traceability stamp).
 * GA drops the `-beta` suffix.
 *
 * Bump this at each release. It drives the launcher footer (lower-left).
 * Keep it in lockstep with the other version surfaces — see
 * documentation/internal/VERSIONING.md for the full bump checklist:
 *   - Android  versionName + versionCode  (packages/lockdown-android/app/build.gradle.kts)
 *   - builderVersion  (licensing-server provision.ts, portal builder/state.ts)
 */
export const PLATFORM_VERSION = '26.2.0614-beta';
